module.exports = __webpack_public_path__ + "static/media/ic_LCD_grey.b5a42f67.svg";